import React from 'react';
import Schedule from '@components/Schedule';

const SchedulePage = () => {
  return <Schedule />;
};

export default SchedulePage;
